<h4 mat-dialog-title>{{data['labelTypeFrais']}} - {{'front.modaleJustificationFraisType.label' | translate}}</h4>
<mat-dialog-content style="min-height: 80px;">
  <div class="row">
    <div class="col-12">
      <p>{{data['descriptionTypeFrais']}}</p>
    </div>
  </div>
  <div class="row">
    <div class="col">
      <textarea maxlength="1000" class="col-12" rows="8" [(ngModel)]="data['descriptionUser']">
      </textarea>
      @if (data['descriptionUser'].length >= 1000) {
        <span style="color:#FF0000">{{'front.modaleJustificationFraisType.textLong' | translate}}</span>
      }
    </div>
  </div>
</mat-dialog-content>
<mat-dialog-actions>
  <button class="btn " [mat-dialog-close]="false" style="margin-right: 15px;">{{'general.annuler' | translate}}</button>
  <button mat-raised-button color="primary" type="submit" [disabled]="data['descriptionUser'].trim().length === 0" (click)="updateFraisTypeDescription()">{{'general.valider' | translate}}</button>
</mat-dialog-actions>
